import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=18d6a840&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=ts"
export * from "./SearchBar.vue?vue&type=script&lang=ts"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=18d6a840&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d6a840",
  null
  
)

export default component.exports